import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 04449961-F211-4FB7-BD87-EDA5F828B41D
 * name arrow-down-box
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-box.svg
 * tags
 * - Arrow 
 */
export const ArrowDownBoxIcon = createSvgIcon(<><path d="M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M11,6V14.5L7.5,11L6.08,12.42L12,18.34L17.92,12.42L16.5,11L13,14.5V6H11Z" /></>, 'ArrowDownBoxIcon');
export default ArrowDownBoxIcon